import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { getViolationColor } from '../../../../../utils/waterSystemHelper';
import { ConnectionIcon, PeopleIcon, ViolationIcon } from '../../../../icons';
import { fShortenNumber } from '../../../../../utils/formatNumber';

interface WaterSystemStatsCardProps {
  totalConnections: number
  totalPopulation: number
  totalViolation: number
}

const StatItem = ({ icon: Icon, value, label, iconProps = {}, flexGrow }) => {
  return (
    <Stack
      alignItems="flex-start"
      spacing={0.5}
      direction={{ xs: 'row', sm: 'row', md: 'column' }} 
      sx={{
        flexGrow,
        flexBasis: 0,
      }}
    >
      <Icon {...iconProps} />
      <Typography
        sx={{
          fontWeight: 600,
          color: (theme) => theme.palette.primary.dark,
          fontSize: { xs: '12px', sm: '14px', lg: '16px' },
        }}
      >
        {value}
      </Typography>
      <Typography
        sx={{
          fontWeight: 500,
          color: (theme) => theme.palette.grey[600],
          fontSize: { xs: '12px', sm: '14px' },
          width: '1rem',
        }}
      >
        {label}
      </Typography>
    </Stack>
  );
};

const WaterSystemStatsCard: React.FC<WaterSystemStatsCardProps> = ({totalConnections, totalPopulation, totalViolation}) => {
  const theme = useTheme();
  const fillColor = getViolationColor(totalViolation, theme);

  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: '0.75rem',
        px: 2,
        py: 2,
      bgcolor: '#FFF',
      }}
    >
        <Typography fontSize="1rem" color="primary.dark" fontWeight={600}>Data</Typography>
        <Divider sx={{ mt: 1 }} />
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'row' }} 
        justifyContent="space-between"
        alignItems={{xs: 'flex-start', sm: 'flex-start', md: "center"}}
        spacing={2}
        sx={{
          mt: 2,
          px: 1,
          flexWrap: 'wrap',
          gap: { xs: 2, sm: 2 },
        }}
      >
        <StatItem
          icon={ConnectionIcon}
          value={fShortenNumber(totalConnections)}
          label="Service connection"
          flexGrow={1}
          iconProps={{ sx: { fontSize: { xs: 20, sm: 24 } } }}
        />
        <StatItem
          icon={PeopleIcon}
          value={fShortenNumber(totalPopulation)}
          label="Total Population"
          flexGrow={1}
          iconProps={{ sx: { fontSize: { xs: 20, sm: 24 } } }}
        />
        <StatItem
          icon={ViolationIcon}
          value={fShortenNumber(totalViolation)}
          label="Total Violation"
          flexGrow={1}
          iconProps={{
            sx: { fontSize: { xs: 20, sm: 24 } },
            fillColor,
          }}
        />
      </Stack>
    </Box>
  )
}

export default WaterSystemStatsCard;
